/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Hiddenpermissionsnotice3Inputs */

const en_usermanagement_permissions_hiddenpermissionsnotice3 = /** @type {(inputs: Usermanagement_Permissions_Hiddenpermissionsnotice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These “behind the scene” permissions can be assigned to a user but will not be shown to them when they check their permissions in the investor portal.`)
};

/**
* | output |
* | --- |
* | "These “behind the scene” permissions can be assigned to a user but will not be shown to them when they check their permissions in the investor portal." |
*
* @param {Usermanagement_Permissions_Hiddenpermissionsnotice3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_hiddenpermissionsnotice3 = /** @type {((inputs?: Usermanagement_Permissions_Hiddenpermissionsnotice3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Hiddenpermissionsnotice3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_hiddenpermissionsnotice3(inputs)
});
export { usermanagement_permissions_hiddenpermissionsnotice3 as "userManagement_permissions_hiddenPermissionsNotice" }